export var Wishlist;
(function (Wishlist) {
    /**
     * Add to wishlist
     */
    let Add;
    (function (Add) {
        Add.path = 'wishlist/add';
    })(Add = Wishlist.Add || (Wishlist.Add = {}));
    /**
     * Remove from wishlist
     */
    let Remove;
    (function (Remove) {
        Remove.path = 'wishlist/remove';
    })(Remove = Wishlist.Remove || (Wishlist.Remove = {}));
    /**
     * Flush wishlist contents
     */
    let Flush;
    (function (Flush) {
        Flush.path = 'wishlist/flush';
    })(Flush = Wishlist.Flush || (Wishlist.Flush = {}));
    /**
     * Remove basket item to wishlist
     */
    let MoveFromBasket;
    (function (MoveFromBasket) {
        MoveFromBasket.path = 'wishlist/moveFromBasket';
    })(MoveFromBasket = Wishlist.MoveFromBasket || (Wishlist.MoveFromBasket = {}));
    /**
     * Send wishlist to email
     */
    let Share;
    (function (Share) {
        Share.path = 'wishlist/share';
    })(Share = Wishlist.Share || (Wishlist.Share = {}));
})(Wishlist || (Wishlist = {}));
